import React from 'react';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
  return (
    <div className="privacy-container">
      <div className="privacy-header">
        <h1>🎤 VoiceMeet Pro®</h1>
        <p>Privacy Policy</p>
        <p className="date">Last updated: January 28, 2025</p>
      </div>

      <div className="privacy-content">
        <section>
          <h2>Introduction</h2>
          <p>VoiceMeet Pro ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you use our audio meeting application.</p>
        </section>

        <section>
          <h2>Information We Collect</h2>
          <p>We collect the following types of information:</p>
          <ul>
            <li><strong>Account Information:</strong> When you register, we collect your name, email address, and password (encrypted).</li>
            <li><strong>Meeting Data:</strong> Meeting titles, schedules, participant lists, and invite links.</li>
            <li><strong>Audio Recordings:</strong> If you choose to record meetings, audio files are stored securely and associated with your account.</li>
            <li><strong>Device Information:</strong> Browser type, device type, and operating system for app optimization.</li>
            <li><strong>Usage Data:</strong> Information about how you interact with the app to improve our services.</li>
          </ul>
        </section>

        <section>
          <h2>How We Use Your Information</h2>
          <p>We use your information to:</p>
          <ul>
            <li>Provide and maintain our audio meeting services</li>
            <li>Create and manage your account</li>
            <li>Enable meeting creation, scheduling, and participation</li>
            <li>Store and manage your meeting recordings</li>
            <li>Send important notifications about your meetings</li>
            <li>Improve and optimize our application</li>
            <li>Respond to your support requests</li>
          </ul>
        </section>

        <section>
          <h2>Audio Data and Recordings</h2>
          <p>Meeting recordings are:</p>
          <ul>
            <li>Only created when explicitly initiated by the meeting host</li>
            <li>Stored securely on our servers with encryption</li>
            <li>Accessible only to the meeting host and authorized participants</li>
            <li>Retained until you choose to delete them or close your account</li>
          </ul>
          <p>We do not listen to, analyze, or share your audio recordings with third parties.</p>
        </section>

        <section>
          <h2>Data Sharing</h2>
          <p>We do not sell, trade, or rent your personal information. We may share data only in these circumstances:</p>
          <ul>
            <li><strong>With Your Consent:</strong> When you explicitly agree to share information</li>
            <li><strong>Service Providers:</strong> With trusted third-party services that help us operate (e.g., cloud hosting, authentication services)</li>
            <li><strong>Legal Requirements:</strong> If required by law or to protect our rights</li>
          </ul>
        </section>

        <section>
          <h2>Data Security</h2>
          <p>We implement industry-standard security measures including:</p>
          <ul>
            <li>HTTPS encryption for all data transmission</li>
            <li>Encrypted password storage using bcrypt hashing</li>
            <li>Secure cloud infrastructure</li>
            <li>Regular security updates and monitoring</li>
          </ul>
        </section>

        <section>
          <h2>Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access your personal data</li>
            <li>Update or correct your information</li>
            <li>Delete your account and associated data</li>
            <li>Export your meeting recordings</li>
            <li>Opt-out of non-essential communications</li>
          </ul>
        </section>

        <section>
          <h2>Guest Participants</h2>
          <p>Guest participants who join meetings without an account:</p>
          <ul>
            <li>Only provide a display name to join meetings</li>
            <li>Are not required to create an account</li>
            <li>Have their participation logged for meeting records only</li>
            <li>Can leave meetings at any time</li>
          </ul>
        </section>

        <section>
          <h2>Cookies and Local Storage</h2>
          <p>We use cookies and browser local storage to:</p>
          <ul>
            <li>Keep you logged in to your account</li>
            <li>Remember your preferences</li>
            <li>Enable offline functionality (PWA)</li>
          </ul>
        </section>

        <section>
          <h2>Children's Privacy</h2>
          <p>VoiceMeet Pro is not intended for children under 13 years of age. We do not knowingly collect personal information from children under 13.</p>
        </section>

        <section>
          <h2>Changes to This Policy</h2>
          <p>We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.</p>
        </section>

        <section className="contact-section">
          <h2>Contact Us</h2>
          <p>If you have questions about this Privacy Policy or your data, please contact us at:</p>
          <p><strong>Email:</strong> <a href="mailto:support@techscriptaid.com">support@techscriptaid.com</a></p>
          <p><strong>Website:</strong> <a href="https://techscriptaid.com">techscriptaid.com</a></p>
        </section>
      </div>

      <div className="privacy-footer">
        <p>&copy; 2025 VoiceMeet Pro by Tech Script Aid. All rights reserved.</p>
        <p><a href="https://voicemeet.techscriptaid.com">Back to VoiceMeet Pro</a></p>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
